import { logEvent } from "firebase/analytics";

const redirectToUrl = async (slug, token, setShowError, analytics) => {
  const url = process.env.REACT_APP_BASE_URL;
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': token ? `Bearer ${token}` : '',
      },
      body: JSON.stringify({ slug }),
    });

    if (response.status === 404) {
      throw new Error('404');
    } else if (response.status === 500) {
      throw new Error('500');
    } else if (response.ok) {
      const data = await response.json();
      const urlObj = new URL(data.url);
      const repairEmbeddedQuery = (u) => {
        for (const [key, value] of [...u.searchParams.entries()]) {
          if (!value || !value.includes('?')) continue;
          const [baseValue, embedded] = value.split('?');
          if (!embedded || !embedded.includes('=')) continue;
          u.searchParams.set(key, baseValue);
          const embeddedParams = new URLSearchParams(embedded);
          for (const [ek, ev] of embeddedParams.entries()) {
            if (ev !== '') {
              u.searchParams.set(ek, ev);
            }
          }
        }
      };

      repairEmbeddedQuery(urlObj);
      const normalizeUtm = (value) => {
        if (value === null || value === undefined) return '';
        if (typeof value !== 'string') return String(value);
        const trimmed = value.trim();
        return trimmed.toLowerCase() === 'undefined' ? '' : trimmed;
      };

      const utmParams = {
        utm_source: normalizeUtm(data.utmSource),
        utm_medium: normalizeUtm(data.utmMedium),
        utm_campaign: normalizeUtm(data.utmCampaign),
        utm_content: normalizeUtm(data.utmContent),
      };

      Object.entries(utmParams).forEach(([key, value]) => {
        if (value !== '') {
          urlObj.searchParams.set(key, value);
        }
      });

      const finalUrl = urlObj.toString();

      logEvent(analytics, 'redirect_event', {
        slug,
        redirectTo: finalUrl,
      });
      window.location.href = finalUrl;
    } else {
      throw new Error('Error al obtener la URL de redireccionamiento');
    }
  } catch (error) {
    console.error('Error al realizar la solicitud:', error);
    setShowError(error.message);
  }
};

const redirectToUrlWithUTM = async (slug, token, setShowError, analytics, utmParams) => {
  const redirectUrl = `${process.env.REACT_APP_UPDATE_URL}/${slug}`;
  const normalizeUtm = (value) => {
    if (value === null || value === undefined) return '';
    if (typeof value !== 'string') return String(value);
    const trimmed = value.trim();
    return trimmed.toLowerCase() === 'undefined' ? '' : trimmed;
  };

  try {
    const response = await fetch(`${process.env.REACT_APP_GET_UTM}/${slug}`, {
      method: 'GET',
      headers: {
        'Authorization': token ? `Bearer ${token}` : '',
      }
    });

    if (response.status === 404) {
      throw new Error('404');
    } else if (response.status === 500) {
      throw new Error('500');
    }

    const data = await response.json();
    console.log('Respuesta de la API:', data);

    const defaultUTMParams = {
      utm_source: normalizeUtm(data.source),
      utm_medium: normalizeUtm(data.medium),
      utm_campaign: normalizeUtm(data.campaign),
      utm_content: normalizeUtm(data.content),
    };

    const fullUrl = new URL(redirectUrl);

    Object.keys(defaultUTMParams).forEach(key => {
      const valueFromOriginalURL = new URLSearchParams(window.location.search).get(key);
      const value = normalizeUtm(valueFromOriginalURL) || normalizeUtm(utmParams[key]) || defaultUTMParams[key];
      console.log(`Valor de ${key}:`, value);
      if (value) {
        fullUrl.searchParams.set(key, value);
      }
    });

    const finalUrl = fullUrl.toString();
    logEvent(analytics, 'redirect_event', {
      slug,
      redirectTo: finalUrl,
      ...utmParams
    });

    window.location.href = finalUrl;

  } catch (error) {
    console.error('Error al realizar la redirección:', error);
    setShowError(error.message);
  }
};

export { redirectToUrl, redirectToUrlWithUTM };
